// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // baseUrl: 'http://192.168.0.146:3000/partner/api/v1/',
  baseUrl: 'https://c0bd03e7.ngrok.io/partner/api/v1/',
  logo_baseUrl: 'https://mindler-partner.s3.ap-south-1.amazonaws.com/partner-logo/',
  featured_photo_baseUrl: 'https://mindler-partner.s3.ap-south-1.amazonaws.com/partner-featured-photos/',
  counsellor_photo_baseUrl: 'https://mindler-partner.s3.ap-south-1.amazonaws.com/counselor-logo/',
  assests_baseUrl: 'https://mindler-partner.s3.ap-south-1.amazonaws.com/partner-assets/',
  razorpay_key: 'rzp_test_ppNhkzyJBxfvNC'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
